import { Button, Icons, Stack, Typography } from '@healthinal/ui';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useGetTherapyByPatientSuspense } from '../../../api/generated/patient-controller/patient-controller.ts';
import { ComplianceCard } from './components/therapy/ComplianceCard.tsx';
import { ConditionCard } from './components/therapy/ConditionCard.tsx';
import { DirectlyObservedTherapyCard } from './components/therapy/DirectlyObservedTherapyCard.tsx';
import { EndTherapyDialog } from './components/therapy/EndTherapyDialog.tsx';
import { HospitalizationCard } from './components/therapy/HospitalizationCard.tsx';
import { IsolationCard } from './components/therapy/IsolationCard.tsx';
import { MedicationChangeHistory } from './components/therapy/MedicationChangeHistory.tsx';
import { SupplementCard } from './components/therapy/SupplementCard.tsx';
import { TherapyCard } from './components/therapy/TherapyCard.tsx';

export const Route = createFileRoute('/patients/$patientId/therapy')({
  component: Therapy,
  staticData: { title: 'Therapie' },
});

function Therapy() {
  const { patientId } = Route.useParams();
  const { data: therapy } = useGetTherapyByPatientSuspense(patientId);
  const [isEndTherapyDialogOpen, setIsEndTherapyDialogOpen] = useState(false);

  return (
    <>
      <Stack direction="row" alignItems="start" justifyContent="space-between">
        <Typography level={'h3'}>Therapie</Typography>
        {therapy && !therapy.finished && (
          <Button endDecorator={<Icons.Cancel />} color={'danger'} onClick={() => setIsEndTherapyDialogOpen(true)}>
            Therapie beenden
          </Button>
        )}
      </Stack>

      <Stack gap={2}>
        <Stack direction={'row'} gap={2} alignItems={'start'}>
          <Stack flex={1} gap={2}>
            <TherapyCard therapy={therapy} patientId={patientId} />
            <ComplianceCard compliance={therapy.therapyCompliance} patientId={patientId} therapyId={therapy.id} />
          </Stack>
          <Stack flex={1} gap={2}>
            <DirectlyObservedTherapyCard patientId={patientId} therapy={therapy} />
            <HospitalizationCard patientId={patientId} therapy={therapy} />
            <IsolationCard patientId={patientId} therapy={therapy} />
            {therapy.finished && <SupplementCard patientId={patientId} therapy={therapy} />}
            <ConditionCard condition={therapy.therapyCondition} patientId={patientId} currentTherapy={therapy} />
          </Stack>
        </Stack>
      </Stack>

      {therapy.id && <MedicationChangeHistory patientId={patientId} />}
      <EndTherapyDialog
        open={isEndTherapyDialogOpen}
        onClose={() => setIsEndTherapyDialogOpen(false)}
        patientId={patientId}
        currentTherapy={therapy}
      />
    </>
  );
}
